/* @flow */

import type { CARD_DATA_MODAL_TYPE } from '../../components/modal/cardModal/CardModalConstsAndTypes';
import type { ChannelMap } from '../../libs/netgemLibrary/v8/types/Channel';
import type { NETGEM_API_V8_METADATA_SCHEDULE_LOCATION } from '../../libs/netgemLibrary/v8/types/MetadataSchedule';
import type { KeyValuePair } from '../jsHelpers/types';

import { type NETGEM_API_V8_RIGHTS, NETGEM_API_V8_RIGHTS_RECORD } from '../../libs/netgemLibrary/v8/types/Rights';
import { getChannelRights } from '../channel/helper';
import { Messenger, MessengerEvents } from '../messenger';
import { type PENDING_OPERATION_DATA_TYPE, PendingOperationKind, PendingOperationReason, storePendingOperation } from './pendingOperations';
import { getRequiredRights, isAccessGranted, showMissingSubscription } from './rights';

const isRecordGranted: (
  isRegisteredAsGuest: boolean,
  isSubscriptionFeatureEnabled: boolean,
  cardData: CARD_DATA_MODAL_TYPE,
  location: NETGEM_API_V8_METADATA_SCHEDULE_LOCATION,
  channels: ChannelMap,
  commercialOffers: ?KeyValuePair<Array<string>>,
  defaultRights: ?NETGEM_API_V8_RIGHTS,
  userRights: Array<string> | null,
) => boolean = (isRegisteredAsGuest, isSubscriptionFeatureEnabled, cardData, location, channels, commercialOffers, defaultRights, userRights) => {
  const { channelId } = location;

  const data: CARD_DATA_MODAL_TYPE | PENDING_OPERATION_DATA_TYPE = {
    ...cardData,
    pendingOperation: {
      operationType: PendingOperationKind.Record,
      reason: PendingOperationReason.RequireSubscription,
    },
  };

  if (isRegisteredAsGuest) {
    // Guest mode: let's open the sign-in page
    storePendingOperation(data);
    Messenger.emit(MessengerEvents.SHOW_SIGN_IN, PendingOperationKind.OpenCard);
    return false;
  }

  if (!isSubscriptionFeatureEnabled) {
    // Subscription feature not enabled: no restriction
    return true;
  }

  const channelRights = getChannelRights(channels, channelId);
  const requiredRights = getRequiredRights(NETGEM_API_V8_RIGHTS_RECORD, location, channelRights, defaultRights);
  if (isAccessGranted(requiredRights, userRights)) {
    // User has required rights
    return true;
  }

  if (!data.item) {
    return false;
  }

  // User rights do not meet required rights: open subscribe page and highlight matching commercial offer
  showMissingSubscription(data as CARD_DATA_MODAL_TYPE, requiredRights, commercialOffers);
  return false;
};

export { isRecordGranted };
